<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th
            v-for="(column, key) in columns"
            :class="'text-' + column.align"
            :key="key"
            @click="sortBy(column)"
          >
          <div class="table-header">
              <div class="table-header-title">
                    {{ column.title }}
              </div> 
               <div v-if="column.sortBy" class="table-header-sort">
     
                  <span :style="{opacity: (sort.orderType === 'ASC'  && sort.orderBy===column.sortBy) ? 1 : 0.4}" class="ti-arrow-circle-up"></span>
                  <span :style="{opacity: (sort.orderType === 'DESC' && sort.orderBy===column.sortBy) ? 1 : 0.4}"  class="ti-arrow-circle-down"></span>
              </div>
          </div>
          </th>
        </slot>
      </thead>
      <tbody>
        <tr width="auto" v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <template v-for="(column, index) in columns">
              <td
              align="right"
              class="control-item"
                v-if="
                  (column.detail === true ||
                    column.remove === true ||
                    column.input === true) &&
                  item.id
                "
                :key="`head-${index}`"
              >
                <button
                  v-if="column.detail === true"
                  @click="openObject(item, card)"
                  class="mr-2 btn btn-sm"
                >
                   <span class="ti-pencil"></span>
                </button>
                <button
                  v-if="column.remove === true"
                  @click="removeItem(item.id)"
                  class="btn btn-sm btn-danger"
                >
                  <span class="ti-trash"></span>
                </button>
                <button
                  v-if="column.delete === true"
                  @click="deleteItem(item.id)"
                  class="btn btn-sm btn-danger"
                >
                  <span class="ti-trash"></span>
                </button>
              </td>
              <td
                v-else
                :align="column.align ? column.align : 'left'"
                :key="index"
                :class="`${column.full === true ? 'full' : ''}`"
              >

                <div v-if="column.dateFormat===true">

                      <span v-if="column.object && item[column.key][column.object]">
                               {{item[column.key][column.object] | dateFormat}}
                      </span>
                      
                      <span v-else> {{item[column.key] | dateFormat}}</span>  
                </div>
                <div v-else-if="column.dateTimeFormat===true">
            

                            <span v-if="column.object && item[column.key][column.object]">
                              {{item[column.key][column.object] | dateTimeFormat}}
                            </span>
                      
                      <span v-else> {{item[column.key] | dateTimeFormat}}</span>  
                </div>

                <div v-else-if="column.checkbox === true">
                  <checkbox
                    v-if="!simple"
                    v-model="val"
                    :value="item.id"
                    color="#ffc107"
                    >{{ itemValue(item, column) }}</checkbox
                  >
                  <div v-if="simple" class="radiobox">
                    <input
                      v-if="simple"
                      :id="card + 'item-' + item.id"
                      :value="item.id"
                      :name="card"
                      v-model="val"
                      type="radio"
                    />
                    <label :for="card + 'item-' + item.id">{{
                      itemValue(item, column)
                    }}</label>
                  </div>
                </div>

    

                <div v-else-if="column.image === true">
                  <img
                    v-if="itemValue(item, column)"
                    :src="itemValue(item, column)"
                    :alt="`img`"
                    class="img"
                  />
                </div>
                <div v-else-if="column.timer === true">
                  <timer :item="item" />
                </div>
                <div v-else>
               
                  <span v-if="column.object && column.key && item[column.key] && column['disableLink']!==true" @click="openObject(item[column.key],column.key,'')" class="link">
                        {{ itemValue(item, column) }}
                  </span>
                  <span v-else-if="column.key_type && item[column.key_type] && item[column.key]"  @click="openObject({id:item[column.key]},item[column.key_type],'')" class="link">
                       {{ itemValue(item, column) }} # {{item[column.key_type]}}
                  </span>
                  <span v-else>
                        {{ itemValue(item, column) }}
                  </span>

                </div>
              </td>
            </template>
          </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import timer from "../components/Timer";

export default {
  components: {
    timer,
  },
  data() {
    return {
      noImage: require("@/assets/img/no-photo-available.png"),
      // val: [],
      sort:{
          orderBy:'created_at',
          orderType:'DESC',
      },
    };
  },
  name: "paper-table",
  props: {
    card: {
      default: null,
    },
    current_page: {
      default: 1,
    },
    columns: Array,
    data: Array,
    type: {
      type: String,
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    simple: {
      default: false,
    },
    subTitle: {
      type: String,
      default: "",
    },
    removeItem: {
      default: function () {},
    },
    deleteItem: {
      default: function () {},
    },
    value: {
      default: function () {
        return [];
      },
    },
    dataObject: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },

    val: {
      get() {
        let val;
        if (!this.simple) {
          val = [];
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id) {
              val.push(this.value[i].id);
            }
          }
        } else {
          val = this.value;
        }

        return val;
      },
      set(val) {
        let result;

        if (!this.simple) {
          result = [];
          for (let i = 0; i < val.length; i++) {
            if (this.dataObject[val[i]]) {
              result.push(this.dataObject[val[i]]);
            }
          }
        } else {
          result = [this.dataObject[val]];
        }
        //console.log(this.value);
        this.$emit("input", result);
      },
    },
  },
  methods: {
    sortBy(column) {
      if (column.sortBy){
          this.sort.orderType = (this.sort.orderType === 'ASC' && this.sort.orderBy === column.sortBy) ? 'DESC' : 'ASC'; 
          this.sort.orderBy = column.sortBy;
          this.$emit('sortby',this.sort);
      }
    },
  
    openObject(item, card, prefix ='') {
      const element = `${prefix}${card}`;
      let elem  =  {};  
      if (Array.isArray(item) ){
             if (item.length) {
               elem = item[0];
             }
      }
      else {
              elem = {...item};
       } 
      let query = Object.assign({}, this.$route.query);
      if (query[element] == elem.id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = elem.id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  
    // change(e) {},
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {    
      let key = column.key;
  
      let titleObject = item[key];

       if ( column.image === true){
         return  (item[key]) ? item[key] : this.noImage ;
      }

      if (typeof item[key] === "object" && item[key] !== null) {
        if (Array.isArray(titleObject) &&  titleObject.length) {
          return titleObject
            .map(function (elem) {
                if (column.object){
                    return elem[column.object];
                 }
            })
            .join(", ");
        } 
         else  if (column.object && titleObject[column.object] ){
               return titleObject[column.object] 
        } 
        else {
          return "-";
        }
      } 
      
      else if (typeof item[key] === "boolean") {
        return item[key] ? "Да" : "Нет";
      }


      if (item[key.toLowerCase()] || item[key.toLowerCase()] === 0) {
        return item[key.toLowerCase()];
      }

      // if (column.object && column.objectDefault) {
      //   return column.objectDefault;
      // }

      return "-";
    },
  },
};
</script>
<style lang="scss">
tr {
  &:last-child {
    padding-right: 100px;
  }
}
.table {
  .img {
    width: 35px;
    height: 35px;
    object-fit: contain;
  }
}

.radiobox {
  display: flex;
  align-items: center;
  & > {
    display: block;
    input {
      margin-right: 10px;
    }
  }
}
.control-item {
  min-width:110px;
  max-width:110px;
  width:110px;
}

</style>
